import { useQuery } from "react-query";
import API from "services";

export const useFetchArtboards = () =>
  useQuery(["Artboards"], API.services.designStudio.getArtboards);
